import styles from "@styles/AppFrame.module.css"
import { useSearchParams } from "next/navigation"
import { lazy, Suspense } from "react"
import HomeView from "./views/HomeView"
import { parseSearchParams } from "../helpers/utils/parseSearchParams"
import PageFrame from "./PageFrame"
import LoadingScreen from "./common/LoadingScreen"

// Lazy load views to reduce initial bundle size
// HomeView is kept as regular import since it's the default view
const SettingsView = lazy(() => import("./settings/SettingsView"))
const LinkedAccountsView = lazy(() => import("./settings/LinkedAccountsView"))
const MessageView = lazy(() => import("./views/MessageView"))
const TaskView = lazy(() => import("./views/TaskView"))
const CalendarView = lazy(() => import("./views/CalendarView"))

export default function AppFrame() {
  const searchParams = useSearchParams()
  const { view } = parseSearchParams(searchParams)

  return (
    <div className={styles.container}>
      {(!view || view === "home") && <HomeView />}
      {view === "settings" && (
        <Suspense fallback={<LoadingScreen />}>
          <SettingsView />
        </Suspense>
      )}
      {view === "linkedAccounts" && (
        <Suspense fallback={<LoadingScreen />}>
          <LinkedAccountsView />
        </Suspense>
      )}
      {view === "messages" && (
        <PageFrame>
          <Suspense fallback={<LoadingScreen />}>
            <MessageView />
          </Suspense>
        </PageFrame>
      )}
      {view === "tasks" && (
        <PageFrame>
          <Suspense fallback={<LoadingScreen />}>
            <TaskView />
          </Suspense>
        </PageFrame>
      )}
      {view === "calendar" && (
        <PageFrame>
          <Suspense fallback={<LoadingScreen />}>
            <CalendarView />
          </Suspense>
        </PageFrame>
      )}
    </div>
  )
}
